// @flow

import { h }             from "preact";
import { PureComponent } from "shared-components";
import styles            from "./styles.scss";
import classNames        from "classnames";
import { connect }       from "preact-redux";
import { Link }          from "react-router-dom";

// import Wrapper from "../../components/Wrapper";

@connect(
  state => ({
    customer : state.customer.data,
    pathname : state.router.location ? state.router.location.pathname : state.server.pathname,
  })
)
export default class AppHeader extends PureComponent {
  render({ customer, pathname }: Props, state: any, { t }: Context) {
    return (
      <header
          class={classNames(
            this.props["class"],
            styles.block
          )}>

        {pathname !== "/checkout/success" ?
          <h1
              class={styles.heading}
              dangerouslySetInnerHTML={{
                __html: t("HEADER.LOGO", {
                  name: customer.firstname ? customer.firstname + (customer.firstname.slice(-1) === "s" ? "" : "s") : ""
                })
              }}
          />
        : null}
      </header>
    );
  }
}
